import generalInformation from './general-information';
import offeringSummary from './offering-summary';
import leaseSummary from './lease-summary';
import pricingMatrix from './pricing-matrix';
import pricingMatrixAnnex from './pricing-matrix-annex';
import annualizedOperatingData from './annualized-operating-data';
import rentSchedule from './rent-schedule';
import leaseNotes from './lease-notes';
import pricingRentData from './pricing-rent-data';

// Each object represents a table.
// There are two types of tables: Name-Value and Matrix

// Table Columns
//  The Name-Value table can have maximum 2 columns (1 name, and 1 value). The value cells can be editable or not.
//  The Matrix table can have unlimited columns. The value cells can be editable or not.

// Cell type & measurement unit
//  Each value cell must have a type ('text', 'number', 'date', or 'dropdown')
//  Each value cell can have a measurement unit ('%', '$', 'Years' etc.)

// Cell Value:
//  An editable value cell has a "stateful" value, a property on the cell
//  A non-editable value cell has a value that is calculated "on the spot", through the getComputedValue function.

// Tooltip
// A non-editable value cell can have a tooltip which describes the cell's formula

export default {
    'general-information': generalInformation,
    'offering-summary': offeringSummary,
    'lease-summary': leaseSummary,
    'pricing-matrix': pricingMatrix,
    'pricing-matrix-annex': pricingMatrixAnnex,
    'annualized-operating-data': annualizedOperatingData,
    'rent-schedule': rentSchedule,
    'lease-notes': leaseNotes,
    'pricing-rent-matrix':pricingRentData
};